import React from 'react';
import PropTypes from 'prop-types';
import Auth from '@Services/Auth';
import RxStructureService from '@Services/RxStructureService';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';
import { ButtonWithIcon } from '@els/els-react--button';
import find from 'lodash/find';
import { FEATURES } from '@Constants/rx-ui/constants';
import { Icon } from '@els/els-react--icon';
import NumberFormatter from '@Utils/NumberFormatter.js';
import { Badge } from '@els/els-react--badge';

import './CommercialSubstancesProviderListItem.scss';

function CommercialSubstancesProviderListItem({ structure, closeMenu, onClick = () => null }) {
  const openInDatabase = (db) => {
    RxStructureService.openInDatabase(db, getValueByNs(structure, 'metadata.originalSearchType'));
    closeMenu && closeMenu();
  };

  const commercialSubstances = find(getValueByNs(structure, 'subLinks', []), { databaseId: '20' });

  if (!commercialSubstances) return null;

  return (
    <li role="menuitem" className="u-els-display-flex">
      <span className="column-provider-logo shopping-cart-block">
        {Auth.isFeatureEnabled(FEATURES.enableDisplaySupplierNumber) && !!structure.supplierNumber && (
          <Badge
            type="subtle"
            className="shopping-cart-badge"
            label="Number of suppliers"
            content={NumberFormatter(structure.supplierNumber)}
          />
        )}
        <Icon sprite="ShoppingCart" isDecorative />
      </span>
      <ButtonWithIcon
        className="provider-link e2e-shopping-cart-commercial-substances"
        sprite="ChevronRight"
        iconRight
        type="link"
        linkIconSize="xs"
        onClick={() => {
          onClick();
          openInDatabase(commercialSubstances);
        }}>
        Commercial Suppliers
      </ButtonWithIcon>
    </li>
  );
}

CommercialSubstancesProviderListItem.propTypes = {
  structure: PropTypes.object.isRequired,
  closeMenu: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

export default CommercialSubstancesProviderListItem;
